import { useEffect } from 'react';
import { useMsal, useIsAuthenticated } from '@azure/msal-react';
import { InteractionRequiredAuthError, InteractionStatus } from '@azure/msal-browser';
import { loginRequest } from '@/auth/msalConfig';

export function useSilentAuth() {
  const { instance, inProgress } = useMsal();
  const isAuthenticated = useIsAuthenticated();

  useEffect(() => {
    // Wait until MSAL is idle and user is not yet authenticated
    if (inProgress !== InteractionStatus.None || isAuthenticated) return;

    const silentRequest = {
      ...loginRequest,
      redirectUri: `${window.location.origin}/blank.html`,
      prompt: "None"
    };

    instance
      .ssoSilent(silentRequest)
      .then((response) => {
        instance.setActiveAccount(response.account);
      })
      .catch((error) => {
        const msg = (error as any)?.message ?? '';
        const code = (error as any)?.errorCode ?? '';
        console.warn('ssoSilent unexpected error:', code, msg);
      });
  }, [inProgress, isAuthenticated, instance]);
}
